<mat-tab-group>
  <mat-tab label="CADASTRO">
    <h1>Dados Cadastrais:</h1>
    <form [formGroup]="formCompanyRegistration" (ngSubmit)="submitCompanyData()">
      <div fxFlex="100">
        <mat-form-field fxFlex="50">
          <input matInput placeholder="Razão Social" formControlName="corporateName" style="text-overflow: ellipsis" required />
        </mat-form-field>

        <mat-form-field fxFlex="50">
          <input matInput placeholder="Nome Fantasia" formControlName="tradingName" style="text-overflow: ellipsis" />
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field fxFlex="13">
          <mat-select placeholder="Tipo de Empresa" formControlName="companyType" required>
            <mat-option [value]="0">Matriz</mat-option>
            <mat-option [value]="1">Filial</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex>
          <input matInput placeholder="Unidade" formControlName="unit" required />
        </mat-form-field>

        <mat-form-field fxFlex="22">
          <input
            matInput
            placeholder="CNPJ da Unidade"
            formControlName="fiscalNumber"
            [textMask]="{
              mask: fiscalNumberMask,
              guide: false,
              keepCharPositions: true
            }"
            required />
        </mat-form-field>

        <mat-form-field fxFlex="10">
          <input matInput placeholder="N° de Vidas" required formControlName="employeeCount" />
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field fxFlex="20">
          <input
            matInput
            placeholder="CNPJ da Matriz"
            formControlName="headOfficeFiscalNumber"
            [textMask]="{
              mask: fiscalNumberMask,
              guide: false,
              keepCharPositions: true
            }"
            required />
        </mat-form-field>

        <mat-form-field fxFlex="40">
          <input matInput placeholder="Inscrição Estadual" formControlName="stateRegistration" />
        </mat-form-field>
        <mat-form-field fxFlex="40">
          <input matInput placeholder="Inscrição Municipal" formControlName="municipalRegistration" />
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field fxFlex>
          <input class="address-field" matInput placeholder="Endereço" formControlName="street" style="text-overflow: ellipsis" required />
        </mat-form-field>

        <mat-form-field fxFlex="15">
          <input class="number-field" matInput placeholder="Número" formControlName="number" required />
        </mat-form-field>

        <mat-form-field fxFlex="20">
          <input matInput placeholder="Complemento" formControlName="complement" />
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field fxFlex>
          <input matInput placeholder="Bairro" formControlName="district" required />
        </mat-form-field>

        <mat-form-field fxFlex>
          <input matInput placeholder="Cidade" formControlName="city" required />
        </mat-form-field>

        <mat-form-field fxFlex="10">
          <input matInput placeholder="UF" formControlName="region" required />
        </mat-form-field>

        <mat-form-field fxFlex="15">
          <input
            matInput
            placeholder="CEP"
            formControlName="zipCode"
            [textMask]="{
              mask: zipCodeMask,
              guide: false,
              keepCharPositions: true
            }"
            required />
        </mat-form-field>
      </div>
    </form>

    <div class="actions-container">
      <button mat-flat-button class="back-btn" (click)="backToSearchCompanies()">
        <mat-icon aria-hidden="false">arrow_back</mat-icon>
        VOLTAR
      </button>
      <button mat-flat-button color="primary" (click)="submitCompanyData()">SALVAR EMPRESA</button>
    </div>
  </mat-tab>
</mat-tab-group>
